import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeHeader = () => {
  return (
    <div className="text-center mb-8">
      <div className="flex justify-center mb-4">
        <div className="flex items-center justify-center w-16 h-16 bg-primary rounded-2xl">
          <Icon name="Utensils" size={32} color="white" />
        </div>
      </div>
      
      <h1 className="text-3xl font-semibold text-foreground mb-2">
        Welcome Back
      </h1>
      
      <p className="text-muted-foreground text-base">
        Sign in to continue planning your perfect dinner parties
      </p>
    </div>
  );
};

export default WelcomeHeader;